import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Enum } from '@app/models/enums/enums';
import { environment } from '@environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class EnumsProxyService {
  private baseUrl = `${environment.proxyUrls.userMasterApi}/api/v1/enums`;
  constructor(private httpClient: HttpClient) {}

  getEnums(): Observable<Enum[]> {
    return this.httpClient.get<Enum[]>(`${this.baseUrl}`);
  }
}
